export const categories = [
  {
    id: 'compressors',
    title: 'Compressors',
    description: 'Industrial air and gas compressors, rotary screw, reciprocating, and centrifugal units for demanding environments.',
    image: 'https://readdy.ai/api/search-image?query=Large%20industrial%20air%20compressor%20in%20modern%20factory%20setting%2C%20heavy%20machinery%2C%20steel%20pipes%20and%20gauges%2C%20dramatic%20lighting%2C%20dark%20industrial%20atmosphere%2C%20high%20contrast%20photography&width=600&height=400&seq=compressors-01&orientation=landscape',
  },
  {
    id: 'pumps',
    title: 'Pumps',
    description: 'Centrifugal, positive displacement, and submersible pumps for water, oil, chemical, and slurry applications.',
    image: 'https://readdy.ai/api/search-image?query=Large%20industrial%20centrifugal%20pump%20with%20steel%20flanges%20and%20piping%2C%20heavy%20duty%20machinery%2C%20dark%20factory%20background%2C%20professional%20industrial%20photography%2C%20metallic%20surfaces%2C%20dramatic%20lighting&width=600&height=400&seq=pumps-01&orientation=landscape',
  },
  {
    id: 'turbines',
    title: 'Turbines',
    description: 'Gas turbines, steam turbines, and turboexpanders for power generation and mechanical drive applications.',
    image: 'https://readdy.ai/api/search-image?query=Massive%20industrial%20gas%20turbine%20engine%20in%20power%20plant%2C%20complex%20rotating%20machinery%2C%20steel%20and%20chrome%20surfaces%2C%20dark%20industrial%20interior%2C%20professional%20engineering%20photography%2C%20dramatic%20spotlighting&width=600&height=400&seq=turbines-01&orientation=landscape',
  },
  {
    id: 'marine',
    title: 'Marine Equipment',
    description: 'Main engines, propulsion systems, auxiliary machinery, and deck equipment for vessels and offshore platforms.',
    image: 'https://readdy.ai/api/search-image?query=Large%20marine%20diesel%20engine%20in%20ship%20engine%20room%2C%20heavy%20machinery%2C%20metal%20pipes%20and%20valves%2C%20dark%20industrial%20atmosphere%2C%20professional%20maritime%20photography%2C%20dramatic%20interior%20lighting&width=600&height=400&seq=marine-01&orientation=landscape',
  },
  {
    id: 'oilgas',
    title: 'Oil & Gas',
    description: 'Drilling equipment, refinery components, pipeline valves, and processing systems for upstream and downstream operations.',
    image: 'https://readdy.ai/api/search-image?query=Oil%20refinery%20at%20night%20with%20industrial%20towers%20and%20piping%2C%20dramatic%20dark%20sky%2C%20flames%20and%20lights%2C%20heavy%20industrial%20infrastructure%2C%20professional%20energy%20photography%2C%20high%20contrast&width=600&height=400&seq=oilgas-01&orientation=landscape',
  },
  {
    id: 'power',
    title: 'Power Generation',
    description: 'Generators, transformers, switchgear, and control systems for thermal, hydro, and renewable power plants.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20power%20plant%20interior%20with%20large%20generators%20and%20electrical%20equipment%2C%20control%20panels%2C%20dark%20industrial%20hall%2C%20professional%20engineering%20photography%2C%20metallic%20surfaces%2C%20dramatic%20lighting&width=600&height=400&seq=power-01&orientation=landscape',
  },
  {
    id: 'electrical',
    title: 'Electrical',
    description: 'Motors, drives, switchboards, cables, and distribution equipment for heavy industrial electrical systems.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20electrical%20control%20panel%20with%20switches%20relays%20and%20circuit%20breakers%2C%20organized%20wiring%2C%20dark%20metal%20enclosure%2C%20professional%20industrial%20photography%2C%20subtle%20LED%20indicators%2C%20technical%20atmosphere&width=600&height=400&seq=electrical-01&orientation=landscape',
  },
  {
    id: 'automation',
    title: 'Automation',
    description: 'PLCs, SCADA systems, sensors, actuators, and robotic components for industrial process control.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20industrial%20automation%20control%20room%20with%20multiple%20monitors%20displaying%20process%20diagrams%2C%20dark%20room%20with%20screen%20glow%2C%20professional%20technology%20photography%2C%20high-tech%20atmosphere%2C%20blue%20and%20amber%20screen%20light&width=600&height=400&seq=automation-01&orientation=landscape',
  },
  {
    id: 'instrumentation',
    title: 'Instrumentation',
    description: 'Pressure transmitters, flow meters, level sensors, analyzers, and calibration equipment for process monitoring.',
    image: 'https://readdy.ai/api/search-image?query=Industrial%20instrumentation%20gauges%20and%20pressure%20meters%20mounted%20on%20steel%20pipeline%2C%20analog%20and%20digital%20displays%2C%20dark%20industrial%20background%2C%20professional%20engineering%20photography%2C%20metallic%20textures%2C%20dramatic%20lighting&width=600&height=400&seq=instrumentation-01&orientation=landscape',
  },
];

export const manufacturers = [
  { id: 'siemens', name: 'Siemens' },
  { id: 'abb', name: 'ABB' },
  { id: 'man', name: 'MAN' },
  { id: 'wartsila', name: 'Wärtsilä' },
  { id: 'sulzer', name: 'Sulzer' },
  { id: 'ksb', name: 'KSB' },
  { id: 'alfalaval', name: 'Alfa Laval' },
  { id: 'liebherr', name: 'Liebherr' },
  { id: 'atlascopco', name: 'Atlas Copco' },
  { id: 'gardnerdenver', name: 'Gardner Denver' },
  { id: 'nuovopignone', name: 'Nuovo Pignone' },
  { id: 'solarturbines', name: 'Solar Turbines' },
  { id: 'ingersollrand', name: 'Ingersoll Rand' },
  { id: 'ariel', name: 'Ariel' },
  { id: 'howden', name: 'Howden' },
];

export const navLinks = [
  { label: 'Products', href: '#products' },
  { label: 'About', href: '#about' },
  { label: 'Manufacturers', href: '#manufacturers' },
  { label: 'Contact', href: '#contact' },
];

export const capabilities = [
  {
    id: 'supply',
    title: 'Supply',
    subtitle: 'Spare Parts for Every Industry',
    description: 'We reliably serve Mining Operations, Construction Projects, Marine Installations and Power Plants.',
    icon: 'ri-stack-line',
  },
  {
    id: 'sourcing',
    title: 'Sourcing',
    subtitle: 'Parts Others Cannot Source',
    description: 'Independent access beyond standard suppliers. Hard-to-find and discontinued components sourced globally.',
    icon: 'ri-search-2-line',
  },
  {
    id: 'variety',
    title: 'Variety',
    subtitle: 'Access To Many Makes and Models',
    description: 'The world is our catalog. OEM, OE, and aftermarket parts from hundreds of manufacturers.',
    icon: 'ri-apps-line',
  },
  {
    id: 'freedom',
    title: 'Freedom',
    subtitle: 'Capable & Independent',
    description: 'Not bound by restrictive dealership contracts. We find the best solution for your operation.',
    icon: 'ri-shield-check-line',
  },
];